module.exports = __webpack_public_path__ + "img/our_product_lk.df29e864.png";